import template from './user-group-memberships.html';

export default {
  template,
  controller: 'UserGroupMembershipsController',
  bindings: {
    user: '<',
  },
};



// WEBPACK FOOTER //
// ./src/modules/user/components/group-memberships/user-group-memberships-component.js